var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Loader',{attrs:{"view":_vm.loadingStatus,"msg":_vm.msg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }